import React from 'react';
import Banner from './Banner/Banner';
import AboutUs from './About/AboutUs';
import './Banner/Banner.scss';
import Box from '@mui/material/Box';
import MuseumColumnDisplay from './MuseumColumnDisplay/MuseumColumnDisplay';

export default function LandingComponents() {
  return (
    <Box className={'container'}>
      <Box>
        <Banner/>
      </Box>
      <Box sx={{mt: 8}}>
        <AboutUs/>
      </Box>
      <Box>
        <MuseumColumnDisplay/>
      </Box>
    </Box>
  );
}
